import React from "react";
import styled from "styled-components";
import Colors from "../../../styles/Colors";
import { H1 } from "../../../styles/Fonts";
import TokenItem from "./TokenItem";
import useVaultTokens from "../../../hooks/useVaultTokens";

const Factory: React.FC = () => {
  const vaultTokens = useVaultTokens();

  return (
    <Container>
      <FactoryContainer>
        <Title>Factory</Title>
        {vaultTokens.map((token) => (
          <TokenItem key={token.tokenAddress} token={token} />
        ))}
      </FactoryContainer>
    </Container>
  );
};

export default Factory;

const Container = styled.div``;

const FactoryContainer = styled.div`
  margin-top: 20px;
  > div:not(:first-child) {
    margin-top: 24px;
  }
`;

const Title = styled(H1)`
  font-size: 24px;
  line-height: 32px;
  text-align: left;
  color: ${Colors.ivory};
  font-family: TT Firs Neue, Goldman-Sans, Helvetica Neue, Helvetica, Roboto,
    PingFang TC, 微軟雅黑, Microsoft Yahei, sans-serif;
  margin-bottom: 20px;
  @media (max-width: 768px) {
    font-size: 20px;
    line-height: 26px;
  }
  @media (max-width: 576px) {
    font-size: 18px;
    line-height: 24px;
  }
`;
